module.exports = __webpack_public_path__ + "img/123.d8d520bd.jpg";